module.exports = __webpack_public_path__ + "static/media/home-2.4b565bd8.jpg";